import { onMessageFromWebApp, sendMessageToWebApp } from "./webAppMessenger";
import { COPY, COPY_SUCCESS, COPY_ERROR } from "./messageTypes";
const clipboard = navigator && navigator.clipboard;

if (clipboard) {
  onMessageFromWebApp(COPY, async ({ text }) => {
    try {
      await clipboard.writeText(text);
      sendMessageToWebApp(COPY_SUCCESS);
    } catch (error) {
      console.error(error);
      sendMessageToWebApp(COPY_ERROR, error);
    }
  });
}
